import {epos2Axios} from "@/interceptors/axios";

class VouchersDataService {
    getAll() {
        return epos2Axios.get('/api/vouchers');
    }


    save(formData) {
       /* const interceptors = () => {
            epos2Axios.interceptors.request.use(config => {
                config.data = formData;
                config.headers.setContentType("multipart/form-data");
                return config;
            });
        };
        interceptors(); //call the interceptors function*/

        return epos2Axios.post(
            `/api/voucher`,
            formData,
            {
                headers: { 'Content-Type': 'multipart/form-data' }
            }
            );
    }

    delete(customerId) {
        return epos2Axios.delete(`/api/deletevoucher/${customerId}`);
    }

    findByVoucher(query) {
        return epos2Axios.get(`/api/vouchers?query=${query}`);
    }

    findVoucherRule(query) {
        return epos2Axios.get(`/api/voucherrule?query=${query}`);
    }
}

export default new VouchersDataService();